// Download Button Enhancement
// =============================================================================

document.addEventListener('DOMContentLoaded', function() {
    const downloadButtons = document.querySelectorAll('.is-style-downloads .wp-block-button__link');
    
    downloadButtons.forEach(button => {
        // Add download attribute if not already present
        if (!button.hasAttribute('download')) {
            // Extract filename from URL or use a default
            const url = button.getAttribute('href');
            if (url) {
                // Try to extract filename from URL
                const filename = url.split('/').pop().split('?')[0];
                if (filename && filename.includes('.')) {
                    button.setAttribute('download', filename);
                } else {
                    // Use a default filename if we can't extract one
                    button.setAttribute('download', 'download');
                }
            }
        }
        
        // Add click event to track downloads
        button.addEventListener('click', function(e) {
            // console.log('Download initiated:', this.getAttribute('href'));
            
            // Optional: Add analytics tracking here
            // gtag('event', 'download', {
            //     'file_name': this.getAttribute('download'),
            //     'file_url': this.getAttribute('href')
            // });
        });
    });
});
